import { CommonModel } from '@telialt/models/src/CommonModel';

import { SEARCH_PAGE_QUERY_PARAM } from '../constants';

const getSegmentPagePrefix = (segment: CommonModel.Segment) => {
    if (segment === 'b2b') {
        return 'verslui';
    }
    if (segment === 'english') {
        return 'eng';
    }
    if (segment === 'russian') {
        return 'rus';
    }

    return 'privatiems';
};

export const getSearchResultsPath = (segment: CommonModel.Segment, keyword?: string) => {
    const prefix = getSegmentPagePrefix(segment);

    const searchParams = keyword ? `?ieskoti=${encodeURIComponent(keyword)}` : '';

    return `/${prefix}/paieska${searchParams}`;
};

export const getFullUrl = (path: string) => {
    return `${process.env.HYBRIS_PUBLIC_URL}${path}`;
};

export const getFullProductUrl = (path: string, variantCode?: string) => {
    const fullUrl = getFullUrl(path);
    if (!variantCode) {
        return fullUrl;
    }

    return `${fullUrl}${fullUrl.indexOf('?') > -1 ? '&' : '?'}variant=${variantCode}`;
};

export const getResultsPathWithPage = (currentPathname: string, currentSearchParams: URLSearchParams, page: number) => {
    const updatedSearchParams = new URLSearchParams(currentSearchParams);
    updatedSearchParams.set(SEARCH_PAGE_QUERY_PARAM, page.toString());

    return [currentPathname, updatedSearchParams.toString()].join('?');
};
